import { Chip } from '@material-ui/core';
import { CloseRounded, DoneRounded, ErrorRounded, ScheduleRounded } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import { getRecordStatusChip } from '@webapps/utils';

const OpcoRecordSteps = ({ opcoRecord }) => {
  const { classes, css, cx, global } = useStyles(styles);

  return (
    <div className={cx(global.fcjs, css({ gap: 24 }))}>
      <div className={cx(global.title, global.blueBar)}>Avancée du dossier OPCO</div>
      <div className={cx(global.fcjs, css({ gap: 4 }))}>
        <Chip 
          className={cx(
            ["ARCHIVED", "OUTDATED"].includes(opcoRecord?.contract?.status)
            ? opcoRecord?.opcoStatus === "PENDING" 
              ? global.chipAction 
              : ["ERROR-CERFA-UPLOAD", "ERROR-CONTRACT-UPLOAD", "ERROR-CONVENTION-UPLOAD", "FORBIDDEN"].includes(opcoRecord?.opcoStatus) 
                ? global.chipError
                : global.chipValid
            : global.chipDisabled, 
            global.fracjs
          )}  
          label={(opcoRecord?.contract?.status === "ARCHIVED" && opcoRecord?.opcoStatus !== "PENDING" && !["ERROR-CERFA-UPLOAD", "ERROR-CONTRACT-UPLOAD", "ERROR-CONVENTION-UPLOAD", "FORBIDDEN"].includes(opcoRecord?.opcoStatus)) ? (
            <div className={cx(global.frac, css({gap: 12}))}><DoneRounded style={{ fontSize: 20 }} /> <div>Dossier transmis</div></div>
          ) : ["ERROR-CERFA-UPLOAD", "ERROR-CONTRACT-UPLOAD", "ERROR-CONVENTION-UPLOAD", "FORBIDDEN"].includes(opcoRecord?.opcoStatus) ? (
            <div className={cx(global.frac, css({gap: 12}))}><CloseRounded style={{ fontSize: 20 }} /> <div>Erreur lors de la transmissions du dossier</div></div>
          ) : (
            <div className={cx(global.frac, css({gap: 12}))}><ScheduleRounded style={{ fontSize: 20 }} /> <div>Transmettre le dossier</div></div>
          )
          } 
          size="medium" 
        />
        {(opcoRecord?.contract?.status === "ARCHIVED" && !["PENDING", "ERROR-CERFA-UPLOAD", "ERROR-CONTRACT-UPLOAD", "ERROR-CONVENTION-UPLOAD", "FORBIDDEN"].includes(opcoRecord?.opcoStatus )) ? getRecordStatusChip(opcoRecord) : (
          <Chip className={cx(global.chipDisabled, global.fracjs)}  
            label={
              <div className={cx(global.frac, css({gap: 12}))}><ScheduleRounded style={{ fontSize: 20 }} /> <div>Statut du dossier</div></div>
            } 
            size="medium" 
          />
        )}
          {/* <Chip 
            className={cx(
              !dataCompletion 
                ? opcoRecord?.contract 
                  ? global.chipValid 
                  : global.chipAction
                : global.chipDisabled, 
                global.fracjs
              )}  
            label={
            <div className={cx(global.frac, css({gap: 12}))}>
              {!opcoRecord?.contract ? (
                <>
                  <ScheduleRounded style={{ fontSize: 20 }} /> <div>Contrat à envoyer</div>
                </>
              ) : (
                <>
                  <DoneRounded style={{ fontSize: 20 }} /> <div>Contrat envoyé</div>
                </>
              )}
            </div>
            } 
            size="medium" 
          /> */}
      </div>
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
 
});

export default OpcoRecordSteps;